import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { fetchFavorites } from "@/lib/api";
import GigCard from "@/components/GigCard";
import { Heart } from "lucide-react";

export default function FavoritesPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [gigs, setGigs] = useState(null);

  useEffect(() => { if (!loading && !user) navigate("/login"); }, [loading, user, navigate]);

  useEffect(() => {
    if (user) fetchFavorites().then(setGigs).catch(() => setGigs([]));
  }, [user]);

  if (!user || gigs === null) return <div className="p-16 text-center">Loading…</div>;

  return (
    <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-10">
      <div className="overline text-primary mb-2">◆ SAVED</div>
      <div className="flex items-end justify-between mb-8 border-b border-black/10 pb-6">
        <h1 className="text-4xl font-bold tracking-tight flex items-center gap-3">
          <Heart className="w-8 h-8 fill-primary text-primary" strokeWidth={1.5}/>
          Your favorites
        </h1>
        <div className="mono text-sm text-muted-foreground">{gigs.length} SAVED</div>
      </div>

      {gigs.length === 0 ? (
        <div className="border border-dashed border-foreground/20 p-16 text-center">
          <Heart className="w-10 h-10 mx-auto mb-4 text-muted-foreground" strokeWidth={1.25}/>
          <div className="text-lg font-medium mb-2">No saved gigs yet</div>
          <p className="text-muted-foreground text-sm mb-6">Tap the heart on any gig to save it here for later.</p>
          <Link to="/browse" data-testid="fav-browse-btn" className="inline-block bg-primary text-primary-foreground px-6 py-3 mono text-sm hover:bg-primary/90">
            EXPLORE GIGS →
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {gigs.map((g, i) => <GigCard key={g.gig_id} gig={g} testId={`fav-gig-${i}`}/>)}
        </div>
      )}
    </div>
  );
}
